<template>
  <div id="journeys-login-form" class="box auth" @keyup.enter="login()">
    <h1 class="title has-text-centered">
      {{ $t('login_form.title') }}
      <span class="has-text-weight-medium">{{ $t('navbar.title') }}</span>
    </h1>

    <div
      class="message is-small is-danger animated fast fadeIn"
      v-if="errorMessage"
    >
      <div class="message-body">{{ errorMessage }}</div>
    </div>

    <div class="field">
      <label for="email" class="label">{{
        $t('login_form.email_label')
      }}</label>
      <div class="control">
        <input
          type="email"
          id="email"
          class="input is-shadowless"
          autocomplete="email"
          required
          autofocus
          v-model="email"
        />
      </div>
    </div>

    <div class="field">
      <label for="password" class="label">{{
        $t('login_form.password_label')
      }}</label>
      <div class="control">
        <input
          type="password"
          id="password"
          class="input is-shadowless"
          autocomplete="current-password"
          required
          v-model="password"
        />
      </div>
    </div>

    <div class="field is-grouped is-grouped-right" v-if="hasRememberMe">
      <div class="control">
        <p-check class="p-icon p-curve p-smooth is-blue" v-model="rememberMe">
          <i class="icon material-icons" slot="extra">&#xE876;</i>
          {{ $t('login_form.remember_me') }}
        </p-check>
      </div>
    </div>

    <div class="field">
      <div class="control has-text-right">
        <router-link
          :to="{
            query: { tab: 'journeys' },
            name: 'reset-password-request',
          }"
          class="has-link"
          >{{ $t('login_form.forgot_password_link') }}</router-link
        >
      </div>
    </div>

    <div class="field">
      <div class="control">
        <gradient-button
          :title="$t('login_form.login_button')"
          :is-loading="isLoading"
          @click.native="login()"
        ></gradient-button>
      </div>
    </div>

    <div class="field field-footer">
      <div class="control has-text-centered">
        <p class="footer-text">{{ $t('login_form.no_account') }}</p>
        <router-link to="register" class="has-link">{{
          $t('register_form.register_button')
        }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from 'services/Auth';
import router from 'router';
import { isLoggedIn } from 'router/helpers';
import { GradientButton } from 'components/buttons';
import ApiError from 'utils/errors/ApiError';

export default {
  components: {
    GradientButton,
  },

  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      isLoading: false,
      rememberMe: false,
      hasRememberMe: false,
    };
  },

  beforeRouteEnter(to, from, next) {
    return isLoggedIn() ? next(false) : next();
  },

  mounted() {
    this.hasRememberMe = !!this.$localStorage.get('rememberMe');
  },

  methods: {
    login() {
      if (this.isLoading) {
        return;
      }

      if (this.email === '' || this.password === '') {
        this.errorMessage = this.$t(
          'login_form.errors.username_or_password_empty'
        );

        return;
      }

      this.isLoading = true;
      this.errorMessage = '';
      Auth.login(this.email, this.password, this.rememberMe)
        .then(() => {
          router.push('/');
        })
        .catch(err => {
          this.errorMessage =
            err.message || this.$t('login_form.errors.login_failed');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
